export const LB_TO_KG = 0.45359237;
export const KG_TO_LBS = 2.2046226;



// WEBPACK FOOTER //
// ./src/constants/weightConversion.js